var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadSave = function SvgFadSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.456 48.385c-10.02 0-16.932 7.725-16.932 16.261 0 8.537-.712 116.968-.356 126.8.356 9.83 8.27 16.1 16.356 16.1 8.087 0 118.524.331 126.622.331 8.097 0 16.575-9.535 16.575-16.618V95.647c0-2.211-.615-5.684-1.539-7.69 0 0 .424.374-.24-.333-.665-.706-34.624-35.746-36.237-37.416-1.8-1.864-.517-.485-.517-.485-1.97-.944-5.354-1.702-7.563-1.693 0 0-86.148.355-96.169.355z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.618 66.238a1.968 1.968 0 0 1 1.988-1.972l13.674.155c1.1.012 1.992.919 1.992 2.022 0 0 .013 30.715.013 35.141 0 4.426 4.96 9.14 9.56 9.14h60.4c4.197 0 8.832-5.801 8.832-9.14V66.442c0-1.104.642-1.377 1.443-.601l29.234 28.317c.796.772 1.444 2.29 1.445 3.388l.143 90.364a3.971 3.971 0 0 1-4 3.98l-120.562-.637c-2.213-.012-4.009-1.817-4.012-4.014l-.15-121.001z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.16 66.679c0-1.106.887-2.002 2-2.002h44.701c1.105 0 2 .9 2 2.002v27.804a1.995 1.995 0 0 1-2 2.001h-44.7c-1.105 0-2-.9-2-2.001V66.679z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.802 119.893c16.176.255 31.833 14.428 31.833 31.728s-14.615 31.782-31.016 31.524c-16.401-.259-32.728-14.764-32.728-31.544s15.735-31.963 31.91-31.708z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.644 151.202c0 9.677 7.685 16.883 16.218 16.844 8.534-.039 15.769-7.128 15.812-16.69.043-9.563-7.708-16.351-15.985-16.351-8.276 0-16.045 6.52-16.045 16.197z",
    fill: "#FFF"
  }))));
};
export { SvgFadSave as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-save.aa713b78.svg";